// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-indicator-icon{background-color:#eff6ff;width:40px;height:40px;border-radius:20px;border:1px solid #e0edff;text-align:center;line-height:40px;font-weight:bold}.step-indicator-icon.active{background-color:#f39b43;color:#fff}\n", ""]);
// Exports
module.exports = exports;
